module.exports = __webpack_public_path__ + "static/img/jishuqianyan.73b9a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jishuqianyan.png
// module id = 2iYH
// module chunks = 1